import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useGetSelfServiceFlowBreadcrumbs} from '../hooks/useGetSelfServiceFlow';
import {HelpCenterBreadcrumbs} from '../shared/HelpCenterBreadcrumbs';
import {LoadingPlaceholder} from './LoadingPlaceholder';

export const SelfServiceFlowBreadcrumbs = () => {
  return (
    <DataFetcher
      request={useGetSelfServiceFlowBreadcrumbs()}
      View={HelpCenterBreadcrumbs}
      Error={() => null}
      Loading={LoadingPlaceholder}
    />
  );
};
